import React, { useState } from "react";
import CartDrawer from "../AdminComponents/CartDrawer";
import HomeCareAppointementScreen from "../AllTabs/HomeCare/HomeCareAppointementScreen";

interface IProps {
  serviceId: string;
  onClose: () => void;
  onSuccess: () => void;
  isOpen: boolean;
}

const HomeCareAppointementDrawer = ({
  serviceId,
  onClose,
  onSuccess,
  isOpen,
}: IProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <CartDrawer
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setIsModalOpen(false);
      }}
      className="bg-white"
      showModal={isModalOpen}
      modalContent={{
        title: "Thank You!",
        description: `Your appointment has been confirm.`,
      }}
    >
      <HomeCareAppointementScreen
        id={serviceId}
        onBack={onClose}
        onSuccess={() => {
          setIsModalOpen(true);
        }}
      />
    </CartDrawer>
  );
};

export default HomeCareAppointementDrawer;
